export enum RuleFilterDataType {
  String = 'String',
  Boolean = 'Boolean',
  Number = 'Number',
  Date = 'Date',
  List = 'List',
  Enum = 'custom',
  Entity = 'entity',
  Metadata = 'Metadata',
  OrderedList = 'OrderedList',
  ObjectList = 'ObjectList',
  LocationInfo = 'LocationInfo',
  Dimensions = 'Dimensions',
  Time = 'Time'
}
